import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type KitWizardMode = "closed" | "create" | "edit";

export interface KitsState {
	selectedKitId: string | null;
	wizardKitId: string | null;
	wizardMode: KitWizardMode;
}

const initialState: KitsState = {
	selectedKitId: null,
	wizardKitId: null,
	wizardMode: "closed"
};

const kitsSlice = createSlice({
	initialState,
	name: "kits",
	reducers: {
		closeKitWizard: (state) => {
			state.wizardKitId = null;
			state.wizardMode = "closed";
		},
		openKitWizard: (state, action: PayloadAction<Exclude<KitWizardMode, "closed">>) => {
			state.wizardKitId = action.payload === "edit" ? state.selectedKitId : null;
			state.wizardMode = action.payload;
		},
		setSelectedKit: (state, action: PayloadAction<string | null>) => {
			state.selectedKitId = action.payload;
		}
	}
});

export const { closeKitWizard, openKitWizard, setSelectedKit } = kitsSlice.actions;

export default kitsSlice.reducer;
